<header class="ac-header">
	<section class="grid dz-grid" [ngClass]="gridClass">
		<section class="row dz-row justify-content-left">
			<span data-cy="header-app-title" class="{{ contentClass.appName }} text-16-bold">
				<ng-container *ngIf="!shouldAllowLowerCaseInTitle"> {{ appName | uppercase }}</ng-container>
				<ng-container *ngIf="shouldAllowLowerCaseInTitle"> {{ appName }}</ng-container>
			</span>

			<span class="icon-action hidden d-block-sm dz-block dz-hidden-md col-sm-6 dz-col-6 text-20 text-align-right">
				<icon *ngIf="!expanded" type="cog" (click)="toggleMobileNav()"></icon> <icon *ngIf="expanded" type="times" (click)="toggleMobileNav()"></icon>
			</span>

			<section class="hidden-sm {{ contentClass.actionButtons }} dz-hidden dz-block-md  text-16-bold text-align-right header-menu-items-container">
				<span *ngFor="let item of itemRefs"><ng-container *ngTemplateOutlet="item"></ng-container></span>
			</section>
		</section>
	</section>
	<nav class="hidden d-block-sm dz-block dz-hidden-md">
		<section class="grid dz-grid mobile-nav" [ngClass]="{ expanded: expanded }">
			<section class="row dz-row">
				<div class="col-sm-24 dz-col text-sm-16" *ngFor="let item of itemRefs"><ng-container *ngTemplateOutlet="item"></ng-container></div>
			</section>
		</section>
	</nav>
</header>
